/**
 * Schedule task control module
 */
import { API_URL, requestData } from "../utils";
export default class ScheduledTaskModule {
  create(enterprise_id, campaign_details, entity_id = "") {
    const { template_id, template_message, message } = campaign_details;
    if (template_id && template_message === message) {
      delete campaign_details.message;
    } else {
      delete campaign_details.template_id;
    }
    delete campaign_details.template_message;
    return requestData(
      "POST",
      `/bulk/scheduled_task?enterprise_id=${enterprise_id}&entity_id=${entity_id}`,
      campaign_details,
    );
  }
  update(task_id, campaign_details) {
    const { template_id, template_text, message } = campaign_details;
    if (template_id && template_text === message) {
      delete campaign_details.message;
    } else {
      delete campaign_details.template_id;
    }
    delete campaign_details.template_text;
    return requestData(
      "PUT",
      `/bulk/scheduled_task?task_id=${task_id}`,
      campaign_details,
    );
  }
  get() {
    return requestData("GET", `/bulk/scheduled_task`);
  }
  getScheduledTaskConfiguration(enterprise_id = "") {
    return requestData("GET", `/bulk/config?enterprise_id=${enterprise_id}`);
  }
  requestQueryLink(query, link = "/bulk/query/scheduled_task") {
    return requestData("GET", link, query);
  }
  async getJwtToken() {
    return await fetch(`${API_URL}/token`, {
      method: "get",
      mode: "cors",
      credentials: "include",
    }).then((res) => res.text());
  }
  resume(task_id, user_id) {
    return requestData("POST", `/bulk/resume-batch-task?task_id=${task_id}`, {
      user_id,
    });
  }
  pause(task_id, user_id) {
    return requestData("POST", `/bulk/pause-batch-task?task_id=${task_id}`, {
      user_id,
    });
  }
  cancel(task_id, user_id) {
    return requestData("POST", `/bulk/cancel-batch-task?task_id=${task_id}`, {
      user_id,
    });
  }
  delete(scheduled_task_id = "") {
    return requestData(
      "DELETE",
      `/bulk/scheduled_task?schedule_task_id=${scheduled_task_id}`,
    );
  }
  preview(data) {
    return requestData("POST", `/bulk/preview/batch-task`, data);
  }
  customLimits = {
    add: (config, enterprise_id) => {
      return requestData(
        "POST",
        `/bulk/distribution_list_limits/${enterprise_id}`,
        config,
      );
    },
    get: (enterprise_id) => {
      return requestData("GET", `/bulk/distribution_list_limits/${enterprise_id}`);
    },
    update: (config, enterprise_id) => {
      return requestData(
        "PUT",
        `/bulk/distribution_list_limits/${enterprise_id}`,
        config,
      );
    },
  };

  getDistributionListConfigLimit() {
    return requestData("GET", "/bulk/config/limits");
  }

  scheduledSendConfig = {
    get: (enterprise_id) => {
      return requestData("GET", `/bulk/scheduled_send_config/${enterprise_id}`);
    },
    update: (config, enterprise_id) => {
      return requestData(
        "PUT",
        `/bulk/scheduled_send_config/${enterprise_id}`,
        config,
      );
    },
    add: (config, enterprise_id) => {
      return requestData(
        "POST",
        `/bulk/scheduled_send_config/${enterprise_id}`,
        config,
      );
    },
  };
}
